import { Measurement } from '../../apis/dtos';
import { DecimalValueOrDefault, GetUserUnitOfMeasurePreference } from '../../utilities/display-utilities';

export const WeightMeasurement = (measurement: Measurement) => {
  const unitPreference: string = GetUserUnitOfMeasurePreference();
  return (
    <>
      <span>
        {DecimalValueOrDefault(unitPreference == 'standard' ? measurement?.standard : measurement?.metric)}
      </span>
      &nbsp;
      <span>
        {unitPreference == 'standard' ? 'lb' : 'kg'}
      </span>
    </>
  );
};
